import _ from 'lodash'

export const filterByFuelType = (data: any, fuel_type?: string) =>
  _.filter(data, (item) =>
    fuel_type === 'diesel'
      ? _.lowerCase(item.fuel_type) === 'diesel'
      : _.lowerCase(item.fuel_type) !== 'diesel',
  )

export const ice_vehicle_filtered = (vehicle_data: any) => filterByFuelType(vehicle_data, 'diesel')

export const ev_vehicle_filtered = (vehicle_data: any) => filterByFuelType(vehicle_data)

export const options_with_id = (data: any, vehicle_type?: string) =>
  _.map(data, (item) => ({
    value: item.id,
    label: `${item.make} ${item.model || ''}`,
    additional_info:
      vehicle_type === 'ice'
        ? `Payload: ${_.round(item.payload / 1000, 2)}t`
        : `Payload: ${_.round(item.payload / 1000, 2)}t, Battery capacity: ${item.battery} kWh`,
  }))

const hv_filtered_uniques = (vehicle_data: any) =>
  _.uniq(_.map(vehicle_data, 'heavy_vehicle_weight_class'))


export const ice_vehicle_options = (vehicle_data: any) => options_with_id(vehicle_data, 'ice')
export const ev_vehicle_options = (vehicle_data: any) => options_with_id(vehicle_data, 'ev')

export const hv_vehicle_weight_option = (vehicle_data: any) =>
  hv_filtered_uniques(vehicle_data).map((item) => {
    const edited_gvm_class = item === 'GVM 3.5t - 4.5t' ? 'GVM 3t - 4.5t' : item
    return {
      value: item,
      label: edited_gvm_class,
    }
  })

// hv_filtered_uniques(vehicle_data).map((item) => {
//   const edited_gvm_class = item === 'GVM 3.5t - 4.5t' ? 'GVM 3t - 4.5t' : item
//   return {
//     value: item,
//     label: edited_gvm_class,
//   }
// })


export const hv_vehicle_type_option = (vehicle_data: any) =>
  _.uniq(_.map(vehicle_data, 'type'))
    .sort()
    .map((item) => ({
      value: item,
      label: item,
    }))

export const hv_availabilities_option = (vehicle_data: any) =>
  _.uniq(_.map(vehicle_data, 'availability'))
    .sort()
    .map((item) => ({
      value: item,
      label: item,
    }))

export const vehicle_models_edit = (data: any) => {
  const res = data.map((item: any) =>
    item.gvm > 3000 && item.gvm <= 4500
      ? { ...item, heavy_vehicle_weight_class: 'GVM 3t - 4.5t' }
      : item.gvm > 4500 && item.gvm <= 8000
        ? { ...item, heavy_vehicle_weight_class: 'GVM 4.5t - 8t' }
        : item.gvm > 8000 && item.gvm <= 11000
          ? { ...item, heavy_vehicle_weight_class: 'GVM 8t - 11t' }
          : item.gvm > 11000 && item.gvm <= 16000
            ? { ...item, heavy_vehicle_weight_class: 'GVM 11t - 16t' }
            : item.gvm > 16000
              ? { ...item, heavy_vehicle_weight_class: 'GVM > 16t' }
              : { ...item, heavy_vehicle_weight_class: item.gvm },
  )
  return res
}
